import React, { useState, } from 'react';
import { Button, Input, Select, Form, Space, Flex, } from 'antd';
import { SearchOutlined, } from '@ant-design/icons';
import { Modal } from '../../../UI/Modal/Modal.component';
import { AdvancedSearchTable } from './AdvancedSearchTable.component';
import { advancedSearch } from '../../../../services/MainService';

const { Option } = Select;

export const AdvancedSearch = ({ pendingState, ...props}) => {

    const [displayModal, setDisplayModal] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [displayResults, setDisplayResults] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [form] = Form.useForm();
    const [filterByDevice, setFilterByDevice] = useState(false);

    const onClick = () => {
        form.resetFields();
        setFilterByDevice(false);
        setDisplayModal(true);
        setSearchQuery('');
        setDisplayResults(false);
    };

    const onFinish = (values) => {
        setSearchQuery(values);
        let data = {queryType: values.searchBy, queryparameter: values.query};
        advancedSearch(data).then( function( response ) {
            setDataSource(response)
            setDisplayResults(true);
        })
        
    };

    const onClear = () => {
        form.resetFields();
        setSearchQuery('');
        setDisplayResults(false);
    };

    const selectFilterHandler = (value) => {

        form.setFieldsValue({
            query: '',
        });

        if(value === 'deviceType' ){
            setFilterByDevice(true);
            form.resetFields();
            form.setFieldsValue({searchBy: 'deviceType'})
            
        } else {
            setFilterByDevice(false);   
        }
    };

    const deviceTypeOptions = (
        <Select placeholder='Select a device type' allowClear>
            <Option value='All'>All Device Types</Option>
            <Option value="AAP">AvaLAN Access Point (AAP)</Option>
            <Option value="CAP">Cable Access Point (CAP)</Option>
            <Option value="CS">Cloud Switch (CS)</Option>
            <Option value="CSBASE">Cloud Switch Base (CS-BASE)</Option>
            <Option value='CSDFS'>Cloud Switch DFS (CS-DFS)</Option>
            <Option value='CSEVC'>Cloud Switch EVC (CS-EVC)</Option>
            <Option value='LTE'>LTE</Option>
            <Option value='LTEEVC'>LTE-EVC</Option>
            <Option value='LTEFMS'>LTE-FMS</Option>
            <Option value='SNS'>Secure Network Service (SNS)</Option>
            <Option value='SNSBASE'>Secure Network Service Base (SNS-BASE)</Option>
            <Option value="SNSDFS">Secure Network Service DFS (SNS-DFS)</Option>
            <Option value="SNSGVR">Secure Network Service GVR (SNS-GVR)</Option>
            <Option value="SUSW">Subscriber Unit (SUSW)</Option>
        </Select>
    );

    const formItemsCommonProps = {
        style: {
            width: '100%'
        },
        rules: [
            {
                required: true,
                message: 'Required field',
            },
        ], 
    }

    const advancedSearchForm = (
        <Form 
            form={form}
            layout='vertical' 
            name='advanced-search'
            onFinish={(values) => onFinish(values)}
            preserve={false}
            initialValues={{searchBy: 'serialNum'}}
            >
            <Flex gap='small'>
                <Flex gap='small' flex={1}>
                    <Form.Item label='Filter by:' name='searchBy' {...formItemsCommonProps}>
                        <Select placeholder='Select a filter' onSelect={(value)=> {selectFilterHandler(value)}}>
                            <Option value='serialNum'>Cloud ID/ Serial Number</Option>
                            <Option value='deviceType'>Device Type</Option>
                            <Option value='oracleID'>Oracle ID</Option>
                            <Option value='sstpip'>SSTPIP</Option>
                            <Option value='contractNumber'>Contract Number</Option>
                            <Option value='streetAddress'>Address</Option>
                            <Option value='city'>City</Option>
                            <Option value='state'>State</Option>
                            <Option value='zip'>Zip Code</Option>
                            <Option value='comment'>Comment</Option>
                            <Option value='phone'>Phone</Option>
                        </Select>
                    </Form.Item>
                    <Form.Item label='Query:' name='query' {...formItemsCommonProps}>
                        {filterByDevice ? deviceTypeOptions : <Input placeholder='Ex: AA1234' autoComplete='off'/>}
                    </Form.Item>
                </Flex>
                <Flex>
                    <Form.Item label=" ">
                        <Space size='small'>
                            <Button onClick={()=> onClear()}>Clear</Button>
                            <Button type='primary' htmlType='submit' icon={<SearchOutlined/>}>Filter</Button>
                        </Space>
                    </Form.Item>
                </Flex>
            </Flex>
        </Form>
    );

    return(
        <>  
            <Button 
                icon={<SearchOutlined/>}
                onClick={()=> onClick()}
                {...props}
            > 
                Advanced Search
            </Button>

            <Modal 
                visible={displayModal} 
                setVisible={setDisplayModal} 
                title='Advanced Search (Devices)'
                actionGroup={false} 
                width={"min(75vw, 1200px)"}
            >
                {advancedSearchForm}

                { displayResults && 
                    <AdvancedSearchTable 
                        pendingState={pendingState} 
                        dataSource={dataSource} 
                        setDisplayModal={setDisplayModal} 
                        query={searchQuery} 
                    />
                }       
            </Modal>
        </>
    );
}